import useLocaleStore from "../store/localeStore";

export type Locale = "en" | "ar";

export type TranslationMap = Record<string, string>;

export const translations: Record<Locale, TranslationMap> = {
  en: {
    // Header
    "header.home": "Home",
    "header.whoIsItFor": "Who's it for",
    "header.newInvestors": "New Investors",
    "header.portfolioInvestors": "Portfolio Investors",
    "header.referAnInvestor": "Refer an Investor",
    "header.whiteLabelSolution": "White Label Solution",
    "header.howItWorks": "How It Works",
    "header.properties": "Properties",
    "header.services": "Services",
    "header.resources": "Resources",
    "header.videos": "Videos",
    "header.blog": "Blog",
    "header.login": "Login",
    "header.signUp": "Sign Up",
    "header.user": "User",
    "header.myProfile": "My Profile",
    "header.dashboard": "Dashboard",
    "header.settings": "Settings",
    "header.updates": "Updates",
    "header.feedback": "Feedback",
    "header.logout": "Logout",
    "header.speakToTeam": "Speak To Our Team",
    "header.loading": "Loading...",
    "header.toggleNav": "Toggle navigation",
    "header.logoAlt": "Logo",
    // Language switcher
    "header.langEn": "EN",
    "header.langAr": "العربية",
    // Filters
    "filters.offMarketListings": "Off Market Property Listings",
    "filters.region": "Region",
    "filters.strategy": "Strategy",
    "filters.propertyType": "Property Type",
    "filters.select": "Select",
    "filters.sortBy": "Sort By:",
    "filters.newestDate": "Newest Date",
    "filters.lowestPrice": "Lowest Price",
    "filters.highestYield": "Highest Yield",
    "filters.highestDiscount": "Highest Discount",
    "filters.clearFilters": "Clear Filters",
    "filters.any": "Any",
    "filters.priceUpTo125": "Up to £125,000",
    "filters.price125to250": "£125,000 - £250,000",
    "filters.price250to500": "£250,000 - £500,000",
    "filters.price500to1M": "£500,000 - £1,000,000",
    "filters.price1Mto5M": "£1,000,000 - £5,000,000",
    "filters.price5MPlus": "£5,000,000+",
    "filters.price": "Price",
    // Listing CTAs
    "listing.signInToViewMore": "Sign In to View More Properties",
    "listing.signInNow": "Sign In Now",
    "listing.accessAllProperties": "Access All Properties",
    "listing.signInToAccessAll": "Sign In to Access All Properties",
    "listing.browseCollection": "Sign in to browse our complete collection of premium investment properties.",
    "listing.browseCollectionMap": "Sign in to browse our complete collection of properties on the map.",
    // Property card
    "card.askingPrice": "Asking Price",
    "card.netMonthlyCashflow": "Net Monthly Cashflow",
    "card.zooplaValuation": "Zoopla Valuation",
    "card.totalInvestment": "Total Investment",
    "card.rentalIncomePcm": "Rental Income (pcm)",
    "card.reserved": "Reserved",
    "card.tenanted": "Tenanted",
    "card.grossYield": "Gross Yield",
    "card.netYield": "Net Yield",
    "card.threeDTourAvailable": "3D Tour Available",
    "card.propertyImage": "Property Image",
    // Search
    "search.label": "Search Properties",
    "search.placeholder": "Enter Street Name or Postcode",
    "search.alt": "Search",
  },
  ar: {
    // Header
    "header.home": "الرئيسية",
    "header.whoIsItFor": "لمن هذا",
    "header.newInvestors": "مستثمرون جدد",
    "header.portfolioInvestors": "مستثمرو المحافظ",
    "header.referAnInvestor": "إحالة مستثمر",
    "header.whiteLabelSolution": "حل العلامة البيضاء",
    "header.howItWorks": "كيف يعمل",
    "header.properties": "العقارات",
    "header.services": "الخدمات",
    "header.resources": "الموارد",
    "header.videos": "فيديوهات",
    "header.blog": "المدونة",
    "header.login": "تسجيل الدخول",
    "header.signUp": "إنشاء حساب",
    "header.user": "المستخدم",
    "header.myProfile": "ملفي",
    "header.dashboard": "لوحة التحكم",
    "header.settings": "الإعدادات",
    "header.updates": "التحديثات",
    "header.feedback": "الملاحظات",
    "header.logout": "تسجيل الخروج",
    "header.speakToTeam": "تحدث مع فريقنا",
    "header.loading": "جاري التحميل...",
    "header.toggleNav": "فتح/إغلاق القائمة",
    "header.logoAlt": "الشعار",
    // Language switcher
    "header.langEn": "EN",
    "header.langAr": "العربية",
    // Filters
    "filters.offMarketListings": "عروض عقارات خارج السوق",
    "filters.region": "المنطقة",
    "filters.strategy": "الاستراتيجية",
    "filters.propertyType": "نوع العقار",
    "filters.select": "اختر",
    "filters.sortBy": "ترتيب حسب:",
    "filters.newestDate": "الأحدث تاريخاً",
    "filters.lowestPrice": "أقل سعر",
    "filters.highestYield": "أعلى عائد",
    "filters.highestDiscount": "أعلى خصم",
    "filters.clearFilters": "مسح الفلاتر",
    "filters.any": "أي",
    "filters.priceUpTo125": "حتى 125,000 £",
    "filters.price125to250": "125,000 - 250,000 £",
    "filters.price250to500": "250,000 - 500,000 £",
    "filters.price500to1M": "500,000 - 1,000,000 £",
    "filters.price1Mto5M": "1,000,000 - 5,000,000 £",
    "filters.price5MPlus": "5,000,000+ £",
    "filters.price": "السعر",
    // Listing CTAs
    "listing.signInToViewMore": "سجّل الدخول لعرض المزيد من العقارات",
    "listing.signInNow": "تسجيل الدخول الآن",
    "listing.accessAllProperties": "الوصول لجميع العقارات",
    "listing.signInToAccessAll": "سجّل الدخول للوصول لجميع العقارات",
    "listing.browseCollection": "سجّل الدخول لتصفح مجموعتنا الكاملة من عقارات الاستثمار المميزة.",
    "listing.browseCollectionMap": "سجّل الدخول لتصفح مجموعتنا الكاملة من العقارات على الخريطة.",
    // Property card
    "card.askingPrice": "سعر الطلب",
    "card.netMonthlyCashflow": "صافي التدفق النقدي الشهري",
    "card.zooplaValuation": "تقييم زوبلا",
    "card.totalInvestment": "إجمالي الاستثمار",
    "card.rentalIncomePcm": "دخل الإيجار (شهرياً)",
    "card.reserved": "محجوز",
    "card.tenanted": "مؤجر",
    "card.grossYield": "العائد الإجمالي",
    "card.netYield": "العائد الصافي",
    "card.threeDTourAvailable": "جولة ثلاثية الأبعاد متاحة",
    "card.propertyImage": "صورة العقار",
    // Search
    "search.label": "البحث في العقارات",
    "search.placeholder": "اسم الشارع أو الرمز البريدي",
    "search.alt": "بحث",
  },
};

export function t(key: string): string {
  const locale = useLocaleStore.getState().locale;
  const map = translations[locale];
  const enMap = translations.en;
  return map?.[key] ?? enMap?.[key] ?? key;
}
